<template>
  <div class="pre-line-text mb-10 mt-1" v-if="filteredDescriptions.length">
    <v-tabs v-model="selectedTab" class="description-tabs">
      <v-tab v-for="(description, key) in filteredDescriptions" :key="key">
        {{ description.label }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab" class="mt-2">
      <v-tab-item v-for="(description, key) in filteredDescriptions" :key="key">
        <div
          class="rich-text-container"
          v-if="isHTML"
          v-html="filteredDescriptions[selectedTab].value"
        />
        <div v-else>
          {{ filteredDescriptions[selectedTab].value }}
        </div>
        <div class="mt-4" v-if="description.files">
          <FileComponent
            class="pb-2"
            v-for="file in description.files"
            :key="file.id"
            :file="file"
            @show="showFile(file)"
            customActions
            disabled
            :showFileName="!isMobile"
          />
        </div>
        <PDFViewFull :data="fileDialog" />
      </v-tab-item>
    </v-tabs-items>
  </div>
  <div v-else>
    -
  </div>
</template>

<script>
import { getFilePreviewSettings } from "@/utils/files";
import FileComponent from "@/components/common/FileComponent";
import PDFViewFull from "@/components/common/PDFViewFull";

export default {
  name: "DescriptionTabs",
  props: {
    descriptions: {
      type: Array,
      required: true
    },
    isHTML: Boolean
  },
  components: { FileComponent, PDFViewFull },
  data() {
    return {
      selectedTab: 0,
      fileDialog: { dialog: false }
    };
  },
  computed: {
    filteredDescriptions() {
      return this.descriptions.filter(Boolean);
    }
  },
  methods: {
    async showFile(file) {
      const filePreviewsettings = await getFilePreviewSettings(file);
      this.fileDialog = {
        ...filePreviewsettings,
        dialog: true
      };
    }
  }
};
</script>

<style lang="scss"></style>
